<template>
  <div class="verification">
    <v-dialog v-model="dialogVisible" max-width="600px">
      <v-card>
        <v-card-title class="headline card-title">
          Notification
        </v-card-title>
        <v-card-text class="modal-body">
          <v-icon class="green-icon mr-2">mdi-check-decagram</v-icon>
          {{ popupMessage }}
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="dialogVisible = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'Verification',
  data() {
    return {
      code: '',
      message: 'Nomor Polis Verified',
      isSuccess: true,
      id: this.$route.params.id,
      dialogVisible: false,
      popupMessage: '',
    };
  },
  mounted() {
    if (this.id !== '') {
      this.showPopup('Nomor Polis ' + this.id + ' Verified');
    }
  },
  methods: {
    showPopup(message) {
      this.popupMessage = message;
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped>
.verification {
  max-width: 400px;
  margin: auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.verification h1 {
  text-align: center;
}
.success {
  color: green;
}
.error {
  color: red;
}

/* Style for modal content */
.modal-body {
  margin-top: 10px;
  padding: 20px;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

/* Style for v-card-title with background */
.card-title {
  background-color: #001f48;
  color: #fff; 
  font-size: 18px;
  padding: 10px;
  position: relative;
}

/* Custom green color for v-icon */
.green-icon {
  color: green;
}

.v-icon {
  font-size: 40px;
  margin-right: 10px;
}
</style>